import React, { Component } from 'react'
import { connect } from 'react-redux'
import RoleList from '../../components/RoleList'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import axios from 'axios'
import { Preloader } from '../../components/Chart/index'
import './style.css'
import Multi from '../../components/Multi'
import UserRolesService from '../../lib/services/userRole/UserRolesService'

class Settings extends Component {
    state = {
        loading: false,
        data: [],
        showEdit: true
    }

    componentDidMount() {
        this.setState({ loading: true }, () => {
            axios.get('/role?roleType=CUSTOM').then(response => {
                this.setState({ data: response.data.body, loading: false })
            })
        })

        // check if the user can see edit column
        let userService = new UserRolesService()
        userService.isEnabled('/role', 'PATCH').then(active => {
            this.setState({ showEdit: active })
        })
    }

    onAdd(row, index) {
        this.props.history.push({
            pathname: `/roles/new`,
            state: { role: null }
        })
    }

    onEdit(row, index) {
        this.props.history.push({
            pathname: `/roles/edit/${row.roleId}`,
            state: { role: row }
        })
    }

    onRemove(row, index) {
        console.log('onSubPartnersRemove')
        this.setState({ loading: true }, () => {
            axios.request({ url: '/role', method: 'DELETE', data: { roleId: row.roleId } }).then(response => {
                console.log('on remove response', response)
                let data = this.state.data
                data.splice(index, 1)
                this.setState({ data: data, loading: false })
            })
        })
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <Multi>
                        {!this.state.data ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <WhiteBox>
                                        <div className="row" style={{ marginTop: '25px' }}>
                                            <div className="col">
                                                <h3>Roles</h3>
                                            </div>
                                        </div>
                                        {this.state.loading && <Preloader transparent />}
                                        <RoleList
                                            showEdit={this.state.showEdit}
                                            onadd={this.onAdd.bind(this)}
                                            onEdit={this.onEdit.bind(this)}
                                            onRemove={this.onRemove.bind(this)}
                                            list={this.state.data}
                                        />
                                    </WhiteBox>
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Settings)
